import { useState, useCallback } from "react";
import { userConfigurationStorage } from "../userConfigurationStorage.js";

const CAP = 5_000;

export function useReadState() {
  const [readIds, setReadIds] = useState<Set<string>>(
    () => new Set(userConfigurationStorage.readIds.get()),
  );

  const markRead = useCallback((id: string) => {
    setReadIds((prev) => {
      if (prev.has(id)) return prev;
      const next = new Set(prev);
      next.add(id);
      let arr = Array.from(next);
      if (arr.length > CAP) arr = arr.slice(arr.length - CAP);
      userConfigurationStorage.readIds.set(arr);
      return next;
    });
  }, []);

  return { readIds, markRead };
}
